import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './MessagesPage.css';
import { useAuth } from '../../context/AuthContext';
import api from '../../api';

const MessagesPage = () => {
  const { token } = useAuth();
  const [conversations, setConversations] = useState([]); // User's conversations
  const [selectedConversation, setSelectedConversation] = useState(null); // Currently selected conversation
  const [newMessage, setNewMessage] = useState(''); // Input for new message
  const [messages, setMessages] = useState([]); // Messages in the selected conversation

  // Fetch user's conversations
  useEffect(() => {
    const fetchConversations = async () => {
      try {
        const response = await axios.get(api.getConversations, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setConversations(response.data.conversations || []);
      } catch (error) {
        console.error('Error fetching conversations:', error);
      }
    };
    fetchConversations();
  }, [token]);

  // Fetch messages for a selected conversation
  const fetchMessages = async (conversationId) => {
    try {
      const response = await axios.get(
        `${api.getMessages(conversationId)}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      setMessages(response.data.messages || []);
    } catch (error) {
      console.error('Error fetching messages:', error);
    }
  };

  // Handle selecting a conversation
  const handleSelectConversation = (conversation) => {
    setSelectedConversation(conversation);
    fetchMessages(conversation._id);
  };

  // Handle sending a message
  const handleSendMessage = async (e) => {
    e.preventDefault();
    if (!newMessage.trim()) return;
    try {
      await axios.post(
        api.sendMessage(selectedConversation._id),
        { content: newMessage },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      setMessages((prev) => [...prev, { content: newMessage, sender: 'You' }]);
      setNewMessage('');
    } catch (error) {
      console.error('Error sending message:', error);
    }
  };

  return (
    <div className="messages-page">
      <div className="messages-sidebar">
        <h3>Conversations</h3>
        {conversations.length > 0 ? (
          conversations.map((conversation) => (
            <div
              key={conversation._id}
              className={`conversation ${
                selectedConversation?._id === conversation._id ? 'active' : ''
              }`}
              onClick={() => handleSelectConversation(conversation)}
            >
              <p>{conversation.title || 'Unnamed Conversation'}</p>
            </div>
          ))
        ) : (
          <p>No conversations yet.</p>
        )}
      </div>

      <div className="chat-box">
        {selectedConversation ? (
          <>
            <div className="chat-header">
              <h3>{selectedConversation.title || 'Conversation'}</h3>
            </div>
            <div className="chat-messages">
              {messages.length > 0 ? (
                messages.map((message, index) => (
                  <div
                    key={index}
                    className={`message ${
                      message.sender === 'You' ? 'outgoing' : 'incoming'
                    }`}
                  >
                    <p>
                      <strong>{message.sender}:</strong> {message.content}
                    </p>
                  </div>
                ))
              ) : (
                <p className="no-messages">No messages yet.</p>
              )}
            </div>
            <form className="message-form" onSubmit={handleSendMessage}>
              <input
                type="text"
                placeholder="Type your message..."
                value={newMessage}
                onChange={(e) => setNewMessage(e.target.value)}
              />
              <button type="submit">Send</button>
            </form>
          </>
        ) : (
          <p className="select-conversation">Select a conversation to start chatting.</p>
        )}
      </div>
    </div>
  );
};

export default MessagesPage;
